// extracted by mini-css-extract-plugin
export default {"header":"styles_header__+2-y5","container":"styles_container__35KZI","brand":"styles_brand__Y2U-c"};